import React, { PureComponent } from 'react';
import { scaleLinear as d3ScaleLinear } from 'd3-scale';
import { range as d3Range } from 'd3-array';

import './XAxis.styl';

class XAxis extends PureComponent {
  render() {
    const tickValues = d3Range(this.props.domain[0], this.props.domain[1], 5);
    const domain = this.props.type === 'left' ? [this.props.domain[1], this.props.domain[0]] : this.props.domain;

    const scaleX = d3ScaleLinear()
      .range([0, this.props.width])
      .domain(domain);

    const tickElements = tickValues.map(item => (
      <g key={`xAxis-tick-${item}-${this.props.type}`}>
        <line
          className="xAxis__tick"
          x1={scaleX(item)}
          y1="0"
          x2={scaleX(item)}
          y2="3"
          transform="translate(0, -15)"
        />
        <text
          key={`xAxis-label-${item}-${this.props.type}`}
          className="xAxis__label"
          x={scaleX(item)}
        >
          {item}
        </text>
      </g>
    ));

    return (
      <g className="xAxis" transform={`translate(${this.props.tranlateX}, ${this.props.tranlateY})`}>
        <line className="xAxis-line" x1="0" y1="-15" x2={this.props.width} y2="-15" />
        {tickElements}
      </g>
    );
  }
}

export default XAxis;



// WEBPACK FOOTER //
// ./src/components/XAxis/index.js